"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Grid = _interopRequireDefault(require("../common/Grid"));
var _emailUtils = require("../../../../utils/emailUtils");
var _Container = _interopRequireDefault(require("../Container"));
var _templateObject, _templateObject2;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var LOGO = 'https://assets.yc.level.travel/email/nps/lt-logo-600.png';
var SCORES = Array.from(Array(10).keys()).map(function (index) {
  return index + 1;
});
var styles = {
  container: {
    width: '100%',
    maxWidth: 580,
    border: '1px solid #ccc',
    background: '#fff',
    textAlign: 'center'
  },
  logo: {
    width: 300,
    maxWidth: '100%',
    height: 50,
    marginTop: 10
  },
  questionWrapper: {
    marginTop: 5,
    marginBottom: 10
  },
  question: {
    padding: 10
  },
  questionText: {
    color: '#000',
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: 1.5
  },
  ratingContent: {
    tableLayout: 'fixed'
  },
  ratingDesktopItem: {
    width: '10%',
    padding: '2px 3px'
  },
  ratingHint: {
    width: '50%',
    paddingTop: 5
  },
  ratingHintText: {
    color: '#888',
    fontSize: '14px',
    fontWeight: 'normal'
  },
  ratingLink: {
    display: 'block',
    borderStyle: 'solid',
    borderWidth: '1px 1px 2px 1px',
    borderColor: '#cecece',
    borderRadius: '3px',
    color: '#666',
    cursor: 'pointer',
    textDecoration: 'none',
    textAlign: 'center',
    fontSize: '18px',
    fontWeight: 500,
    paddingTop: 10,
    paddingBottom: 10,
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.3)',
    background: "linear-gradient(\n      to bottom,\n      #fff 0%,\n      #f6f6f6 47%,\n      #ededed 100%\n    )"
  }
};
var NPS = function NPS(_ref) {
  var links = _ref.links;
  return /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    fullWidth: true,
    style: styles.container
  }, /*#__PURE__*/_react["default"].createElement("img", {
    alt: "FAQ",
    style: styles.logo,
    src: LOGO
  }), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    style: styles.questionWrapper
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"].Row, null, /*#__PURE__*/_react["default"].createElement(_Grid["default"].Cell, {
    align: "center",
    style: styles.question
  }, /*#__PURE__*/_react["default"].createElement("span", {
    style: styles.questionText
  }, "\u041D\u0430\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0432\u0435\u0440\u043E\u044F\u0442\u043D\u043E, \u0447\u0442\u043E \u0432\u044B \u043F\u043E\u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u0442\u0435 Level.Travel", /*#__PURE__*/_react["default"].createElement("br", null), " \u0441\u0432\u043E\u0438\u043C \u0434\u0440\u0443\u0437\u044C\u044F\u043C \u0438\u043B\u0438 \u0440\u043E\u0434\u0441\u0442\u0432\u0435\u043D\u043D\u0438\u043A\u0430\u043C?"))), /*#__PURE__*/_react["default"].createElement(_Grid["default"].Row, null, /*#__PURE__*/_react["default"].createElement(_Grid["default"].Cell, {
    style: {
      padding: '5px 15px'
    }
  }, /*#__PURE__*/_react["default"].createElement(RatingDesktop, null, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    style: styles.ratingContent
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"].Row, null, SCORES.map(function (score, index) {
    return /*#__PURE__*/_react["default"].createElement(_Grid["default"].Cell, {
      key: score,
      style: styles.ratingDesktopItem
    }, /*#__PURE__*/_react["default"].createElement("a", {
      href: links[index],
      style: styles.ratingLink
    }, score));
  })), /*#__PURE__*/_react["default"].createElement(_Grid["default"].Row, null, /*#__PURE__*/_react["default"].createElement(_Grid["default"].Cell, {
    colSpan: SCORES.length,
    style: {
      padding: 3
    }
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    style: styles.ratingContent
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"].Row, null, /*#__PURE__*/_react["default"].createElement(_Grid["default"].Cell, {
    style: styles.ratingHint
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: _objectSpread(_objectSpread({}, styles.ratingHintText), {}, {
      textAlign: 'left',
      marginLeft: -10
    })
  }, "\u041A\u0440\u0430\u0439\u043D\u0435 \u043C\u0430\u043B\u043E\u0432\u0435\u0440\u043E\u044F\u0442\u043D\u043E")), /*#__PURE__*/_react["default"].createElement(_Grid["default"].Cell, {
    style: styles.ratingHint
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: _objectSpread(_objectSpread({}, styles.ratingHintText), {}, {
      textAlign: 'right',
      marginRight: -10
    })
  }, "\u041F\u0440\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u043D\u0430\u0432\u0435\u0440\u043D\u044F\u043A\u0430")))))))), /*#__PURE__*/_react["default"].createElement(RatingMobile, {
    style: {
      display: 'none'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"].Row, null, /*#__PURE__*/_react["default"].createElement(_Grid["default"].Cell, {
    style: _objectSpread(_objectSpread({}, styles.ratingHint), {}, {
      paddingBottom: 5
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: _objectSpread(_objectSpread({}, styles.ratingHintText), {}, {
      textAlign: 'center'
    })
  }, "\u041A\u0440\u0430\u0439\u043D\u0435 \u043C\u0430\u043B\u043E\u0432\u0435\u0440\u043E\u044F\u0442\u043D\u043E"))), /*#__PURE__*/_react["default"].createElement(_Grid["default"].Row, null, /*#__PURE__*/_react["default"].createElement(_Grid["default"].Cell, null, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    style: styles.ratingContent
  }, SCORES.map(function (score, index) {
    return /*#__PURE__*/_react["default"].createElement(_Grid["default"].Row, {
      key: score
    }, /*#__PURE__*/_react["default"].createElement(_Grid["default"].Cell, {
      style: {
        padding: '3px 0'
      }
    }, /*#__PURE__*/_react["default"].createElement("a", {
      href: links[index],
      style: styles.ratingLink
    }, score)));
  })))), /*#__PURE__*/_react["default"].createElement(_Grid["default"].Row, null, /*#__PURE__*/_react["default"].createElement(_Grid["default"].Cell, {
    style: styles.ratingHint
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: _objectSpread(_objectSpread({}, styles.ratingHintText), {}, {
      textAlign: 'center'
    })
  }, "\u041F\u0440\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u043D\u0430\u0432\u0435\u0440\u043D\u044F\u043A\u0430"))))))));
};
var RatingDesktop = (0, _styledComponents["default"])(_Grid["default"]).withConfig({
  displayName: "NPS__RatingDesktop",
  componentId: "sc-8pdge3-0"
})(["", ""], (0, _emailUtils.mobileStyles)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    display: none !important;\n  "]))));
var RatingMobile = (0, _styledComponents["default"])(_Grid["default"]).withConfig({
  displayName: "NPS__RatingMobile",
  componentId: "sc-8pdge3-1"
})(["", ""], (0, _emailUtils.mobileStyles)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n    display: block !important;\n  "]))));
var _default = exports["default"] = NPS;